import { cn } from "@base/lib/utils";
import { useSafeAreaInset } from "@base/ui/SafeArea/useSafeAreaInset";
import type { ReactNode } from "react";

interface FixedBottomCTAProps {
  children: ReactNode;
  className?: string;
  bottomOffset?: number;
}

export function FixedBottomCTA({ children, className, bottomOffset = 16 }: FixedBottomCTAProps) {
  const { bottom } = useSafeAreaInset();

  return (
    <div
      className={cn("fixed right-0 bottom-0 left-0 p-4 bg-white", className)}
      style={{ paddingBottom: `calc(${bottom}px + ${bottomOffset}px)` }}
    >
      {children}
    </div>
  );
}
